/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/accounting_medium'
export default icon
